export default function PageHeader({ title, subtitle, actions, eyebrow }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-8 fade-up" data-testid="page-header">
      <div>
        {eyebrow && (
          <div className="text-xs uppercase tracking-[0.15em] text-[#8E9992] font-medium mb-2">{eyebrow}</div>
        )}
        <h1 className="font-heading text-3xl lg:text-4xl font-semibold text-[#2A332C] tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-[#5C6660] mt-2 max-w-xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2 flex-shrink-0">{actions}</div>}
    </div>
  );
}
